import { render, staticRenderFns } from "./OtherOptions.vue?vue&type=template&id=09797722&scoped=true&"
import script from "./OtherOptions.vue?vue&type=script&lang=js&"
export * from "./OtherOptions.vue?vue&type=script&lang=js&"
import style0 from "./OtherOptions.vue?vue&type=style&index=0&id=09797722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09797722",
  null
  
)

export default component.exports